import { axiosInstance } from '@/lib/axios'
import { UserRoleModel } from '@/app/models/createCompanyModel'

export interface InitUploadRequest {
  fileName: string
  fileSize: number
  companyId: string
  userId: string
  userRoles: UserRoleModel[]
}

export interface InitUploadResponse {
  uploadUrl: string
  uploadId: string
  expiresAt: string
}

export interface CompleteUploadRequest {
  uploadId: string
}

export interface CompleteUploadResponse {
  uploadId: string
  message: string
}

export interface UploadStatusResponse {
  status: 'queued' | 'downloading' | 'extracting' | 'restoring' | 'creating_company' | 'completed' | 'failed' | 'unknown'
  progress?: number
  step?: string
  errorMessage?: string
  companyId?: string
  databaseId?: number
}

export function initDatabaseBackupUpload(request: InitUploadRequest) {
  return axiosInstance.post<InitUploadResponse>(
    '/config-api/databaseBackup/initUpload',
    request,
  )
}

export function completeDatabaseBackupUpload(request: CompleteUploadRequest) {
  return axiosInstance.post<CompleteUploadResponse>(
    '/config-api/databaseBackup/completeUpload',
    request,
  )
}

export function getUploadStatus(uploadId: string) {
  return axiosInstance.get<UploadStatusResponse>(
    `/config-api/databaseBackup/status/${uploadId}`,
  )
}

